import Entity from '@/common/models/entity'

export default class RatingListCandidate extends Entity {
  public salutation = ''
  public title = ''
  public firstName = ''
  public lastName = ''
  public numOfRatings = 0
  public numOfCompetences = 0
}
